import React, { memo } from "react";
import { Virtuoso } from "react-virtuoso";
import type { ComponentProps, CSSProperties, ReactNode } from "react";

type VirtuosoBaseProps = ComponentProps<typeof Virtuoso>;

export interface CustomVirtualScrollProps<T = unknown>
  extends Omit<VirtuosoBaseProps, "style" | "totalCount" | "itemContent"> {
  items?: T[];
  height?: CSSProperties["height"];
  width?: CSSProperties["width"];
  totalCount?: number | null;
  fixedItemHeight?: number;
  renderItem: (index: number, item: T) => ReactNode;
  style?: CSSProperties;
}

function CustomVirtualScroll<T = unknown>({
  items = [],
  height = "400px",
  width = "370px",
  totalCount = null,
  fixedItemHeight,
  renderItem,
  style = {},
  ...rest
}: CustomVirtualScrollProps<T>) {
  return (
    <Virtuoso
      style={{ height, width, ...style }}
      totalCount={totalCount || items?.length}
      fixedItemHeight={fixedItemHeight}
      itemContent={(index) => {
        const item = items[index];
        return item ? renderItem(index, item) : null;
      }}
      {...rest}
    />
  );
}

export default memo(CustomVirtualScroll) as typeof CustomVirtualScroll;
